import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../CommonStyles/commonstyles.module.scss";
import noImageFound from "../../../../assets/images/extras/noImgFound.png";
import uploadedImage from "../../../../assets/images/svg/noData.png";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useDispatch, useSelector } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import {
  useDeleteEquipment,
  useFetchAllEquipments,
} from "../../../../hooks/partnerHook/usePartnerEquipment";
import { updateEquipmentsData, updateKycData } from "../../../../store/Partner/partnerDataSlice";
import { useDeleteKyc, useFetchKycDocument } from "../../../../hooks/partnerHook/usePartnerKyc";

const KycDocuments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.partner.user);
  const partnerId = userData?.partner?.id;

  const {
    data: kycData,
    isPending,
    isError,
  } = useFetchKycDocument(partnerId);

  const {
    mutate: deleteKyc,
    isSuccess: kycDeleted,
    isError: deletionError,
  } = useDeleteKyc();

  const [kycDocuments, setKycDocuments] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState("");

  useEffect(() => {
    if (kycData) {
      console.log("hlllooooooooooooo",kycData)
      dispatch(updateKycData(kycData));
    }
  }, [dispatch, kycData]);

  const savedKycDocuments = useSelector((state) => state.partner.kyc);
  console.log(savedKycDocuments);
  useEffect(() => {
    if (savedKycDocuments) {
      setKycDocuments(savedKycDocuments);
    }
  }, [savedKycDocuments]);

  const handleDelete = () => {
    if (deleteId) {
      deleteKyc({ partnerId, kycId: deleteId });
      setShowDeleteModal(false);
    }
  };

  const handleNavigateToDetails = (kycId) => {
    navigate(`/dashboard/kycdocuments/${kycId}`);
  };

  if (isPending) {
    return <h2>Loading...</h2>;
  }

  if (isError) {
    return <h2>Error! Please refresh and try again.</h2>;
  }

  return (
    <div className={styles.dashboardContainer}>
      <h2 className={styles.browseEquipmentsTitle}>Browse All KYC Documents</h2>

      {kycDocuments.length > 0 ? (
        <div className={styles.dashboardGridContainer}>
          {kycDocuments.map((kyc) => (
            <div
              key={kyc.kyc_id}
              className={styles.dashboardCardWrapper}
              onClick={() => handleNavigateToDetails(kyc.kyc_id)}
            >
              <div className={styles.dashboardCard}>
                <div className={styles.dashboardCardImageContainer}>
                  <img
                    src={
                      kyc.doc_url?.length > 0
                        ? kyc.doc_url
                        : noImageFound
                    }
                    alt={kyc.title || "KYC Document"}
                    className={styles.droneCardImg}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImageFound;
                    }}
                  />
                </div>
                <div className={styles.dashboardCardBody}>
                  <div className={styles.dashboardCardStack}>
                    <h5 className={styles.dashboardCardCategoryButton}>
                      {kyc.doc_type || "Fetching..."}
                    </h5>
                    <h5 className={styles.dashboardCardVerifiedButton}>
                      {kyc.verified ? "Verified" : "Not Verified"}
                    </h5>
                  </div>
                  <div className={styles.equipmentHeader}>
                    <h5 className={styles.dashboardCardCategoryTitle}>
                      {kyc.first_name ? `${kyc.first_name} ${kyc.last_name}`: "Fetching..."}
                    </h5>
                    <RiDeleteBin5Line
                      className={styles.deleteIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteId(kyc.kyc_id);
                        setDeleteName(kyc.title);
                        setShowDeleteModal(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.noDataSection}>
          <img
            src={uploadedImage}
            alt="No Data"
            className={styles.noDataImage}
          />
          <h4 className={styles.noEquipmentText}>No Documents Added</h4>
          <p className={styles.noEquipmentDescription}>
            Comply with regulations by completing the KYC verification process.
          </p>
        </div>
      )}
      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={kycDeleted}
          isError={deletionError}
          contentName={deleteName}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

export default KycDocuments;
